import React from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import Categorys from '../guia/categorys.json'

const Pills = ({ activedCategory, updateCategory, searchValue }) => {
  const [viewportRef] = useEmblaCarousel({
    containScroll: "keepSnaps",
    align: 'start',
    dragFree: false
  });

  return (
    <div className="nav-pills embla">
      <div className="embla__viewport" ref={viewportRef}>
        <div className="embla__container">
        <button type='button' className={`embla__slide nav-link ${(activedCategory.id === 0 || searchValue) && 'active'}`} onClick={() => updateCategory({ id: 0, name: 'Todas' })}>Todas</button>
          {Categorys.categorys.map((cat, i) => (
            <button type='button' key={`pill-${i}`} className={`embla__slide  nav-link  ${activedCategory.id == cat.id && !searchValue && 'active'}`} onClick={() => updateCategory({ id: cat.id, name: cat.name })}>{cat.name}</button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Pills
